import React from "react";

interface CategoryItem {
  id: string;
  label: string;
  count?: number;
}

interface CategorySidebarProps {
  categories: CategoryItem[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  className?: string;
}

const CategorySidebar = ({
  categories,
  selectedCategory,
  onCategoryChange,
  className = "",
}: CategorySidebarProps) => {
  const handleCategoryClick = (category: CategoryItem) => {
    onCategoryChange(category.label);
  };

  return (
    <div
      className={`fixed left-[100px] top-1/2 -translate-y-1/2 z-30 hidden 2xl:block ${className}`}
    >
      <div className="bg-white/70 backdrop-blur-sm border border-gray-200/60 rounded-xl shadow-md p-5 min-w-[160px] h-auto">
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-2 font-serif-kr">카테고리</h3>
          <div className="w-8 h-0.5 bg-gray-800 rounded-full"></div>
        </div>

        <nav className="space-y-1.5">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category)}
              className={`
                w-full text-left px-3 py-2.5 rounded-lg transition-all duration-150 flex items-center justify-between group text-base cursor-pointer font-serif-kr
                ${
                  selectedCategory === category.label
                    ? "text-gray-900 font-bold"
                    : "text-gray-600 font-normal hover:text-gray-800 hover:font-semibold"
                }
              `}
            >
              <span>{category.label}</span>
            </button>
          ))}
        </nav>

        <div className="flex justify-center mt-5 space-x-1 opacity-30">
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default CategorySidebar;
